export default {
  login: {
    welcome: 'مرحباً بعودتك',
    subtitle: 'سجل الدخول لمتابعة التسوق',
    phonePlaceholder: 'الرجاء إدخال رقم الهاتف',
    passwordPlaceholder: 'الرجاء إدخال كلمة المرور',
    showPassword: 'إظهار',
    hidePassword: 'إخفاء',
    loginButton: 'تسجيل الدخول',
    registerButton: 'تسجيل مجاني',
    title: 'تسجيل الدخول',
    subtitle2: 'تسوق عالمي في مكان واحد واكسب المكافآت',
    logging: 'جارٍ تسجيل الدخول...',
    phoneRequired: 'الرجاء إدخال رقم الهاتف',
    passwordRequired: 'الرجاء إدخال كلمة المرور',
    loginSuccess: 'تم تسجيل الدخول بنجاح',
    loginFailed: 'فشل تسجيل الدخول',
    loginError: 'خطأ في تسجيل الدخول، يرجى المحاولة مرة أخرى لاحقاً'
  },
  register: {
    title: 'إنشاء حساب',
    subtitle: 'انضم إلينا وابدأ رحلة التداول الخاصة بك',
    username: 'اسم المستخدم',
    phone: 'رقم الهاتف',
    loginPassword: 'كلمة مرور الدخول',
    transactionPassword: 'كلمة مرور المعاملات',
    invitationCode: 'رمز الدعوة',
    usernamePlaceholder: 'الرجاء إدخال اسم المستخدم',
    phonePlaceholder: 'الرجاء إدخال رقم الهاتف',
    loginPasswordPlaceholder: 'الرجاء إدخال كلمة مرور الدخول',
    transactionPasswordPlaceholder: 'الرجاء إدخال كلمة مرور المعاملات',
    invitationCodePlaceholder: 'الرجاء إدخال رمز الدعوة',
    registerButton: 'تسجيل',
    hasAccount: 'لديك حساب بالفعل؟ تسجيل الدخول',
    errorUsername: 'الرجاء إدخال اسم المستخدم',
    errorPhone: 'الرجاء إدخال رقم الهاتف',
    errorLoginPassword: 'الرجاء إدخال كلمة مرور الدخول',
    errorTransactionPassword: 'الرجاء إدخال كلمة مرور المعاملات',
    errorInviteCode: 'الرجاء إدخال رمز الدعوة',
    registerSuccess: 'تم التسجيل بنجاح'
  },
  tabbar: {
    home: 'الرئيسية',
    purchase: 'سجل الطلبات',
    grabbing: 'تقديم طلب',
    kefu: 'خدمة العملاء',
    my: 'حسابي'
  },
  home: {
    orderCount: 'عدد الطلبات',
    upgradeAmount: 'شحن للترقية',
    recharge: 'شحن الرصيد',
    withdraw: 'سحب',
    team: 'إدارة الفريق',
    commission: 'الحصول على عمولة',
    newProducts: 'وصل حديثاً',
    newProductsDesc: 'أحدث الموديلات للموسم الجديد والمجموعات المستقبلية.',
    buyNow: 'اشترِ الآن',
    nowAvailable: 'متوفر الآن',
    nowAvailableDesc: 'استعد لموسم الأعراس، وجهز أمتعتك لرحلتك القادمة، وحدّث خزانة ملابسك دون أي التزام. مع برنامج الاستئجار الجديد لدينا، يمكنك تجربة أحدث صيحات الموضة والالتزام بميزانيتك دون اشتراك.',
    footerTitle: 'Desigual.com',
    footerFollow: "تابعنا على {'@'}Desigual.com وشارك إطلالاتك المفضلة من Desigual.com!",
    footerShop: 'تصفح تشكيلتنا'
  },
  purchase: {
    all: 'الكل',
    pending: 'قيد الانتظار',
    completed: 'مكتمل',
    frozen: 'مجمد',
    balance: 'رصيد الحساب',
    orderTime: 'وقت الطلب',
    orderId: 'رقم الطلب',
    totalAmount: 'إجمالي الطلب',
    commission: 'العمولة',
    expectedReturn: 'العائد المتوقع',
    submitOrder: 'تأكيد الطلب',
    orderCompleted: 'تم إنجاز الطلب',
    loading: 'جارٍ التحميل...',
    noData: 'لا توجد بيانات للطلبات',
    noMore: 'لا يوجد المزيد',
    orderSuccess: 'تم استلام الطلب بنجاح',
    orderNumber: 'رقم الطلب',
    rating: 'التقييم',
    notSubmit: 'عدم التقديم الآن',
    submitNow: 'تقديم الآن',
    submitting: 'جارٍ التقديم...',
    submitFailed: 'فشل التقديم',
    grabOrderFailed: 'فشل استلام الطلب، يرجى المحاولة لاحقاً',
    getOrderInfoFailed: 'فشل الحصول على تفاصيل الطلب',
    submitOrderFailed: 'فشل التقديم، يرجى المحاولة لاحقاً'
  },
  common: {
    home: 'الرئيسية',
    about: 'من نحن',
    contact: 'اتصل بنا',
    purchase: 'سجل الطلبات',
    grabbing: 'تقديم طلب',
    my: 'حسابي',
    login: 'تسجيل الدخول',
    register: 'تسجيل',
    kefu: 'خدمة العملاء',
    loadDataError: 'فشل تحميل البيانات، يرجى المحاولة لاحقاً',
    success: 'العملية ناجحة',
    failed: 'فشلت العملية',
    submitSuccess: 'تم التقديم بنجاح',
    submitFailed: 'فشل التقديم',
    submitting: 'جارٍ التقديم...'
  },
  grabbing: {
    accountAmount: 'مبلغ الحساب',
    accountBalance: 'رصيد الحساب',
    getCommission: 'الحصول على عمولة',
    ordersGrabbedToday: 'الطلبات المستلمة اليوم',
    orderCount: 'عدد الطلبات',
    operationSteps: 'خطوات العملية',
    step1: '1. انقر فوق زر بدء المهمة واتبع التعليمات',
    step2: '2. بعد إكمال المهمة، يمكنك تسوية العمولة وإضافتها للرصيد',
    grabOrder: 'استلام الطلب',
    pleaseWait: 'يرجى الانتظار',
    grabSuccess: 'تم استلام الطلب بنجاح',
    grabTime: 'وقت الطلب',
    grabNumber: 'رقم الطلب',
    orderTotal: 'إجمالي الطلب',
    commission: 'العمولة',
    expectedReturn: 'العائد المتوقع',
    rating: 'التقييم',
    notSubmit: 'عدم التقديم الآن',
    submitNow: 'تقديم الآن',
    submitting: 'جارٍ التقديم...'
  },
  kefu: {
    title: 'خدمة العملاء',
    intro: {
      line1: 'إذا كان لديك أي أسئلة أو تحتاج إلى مساعدة،',
      line2: 'يرجى الاتصال بخدمة العملاء عبر الإنترنت لحل مشكلتك'
    },
    serviceTime: {
      label: 'أوقات العمل',
      text: 'ممثل خدمة العملاء الخاص بك',
      online: 'متصل'
    },
    contact: {
      title: 'اتصل',
      name: 'عبر الإنترنت',
      status: 'استشارة',
      feature1: 'رد فوري',
      feature2: 'خدمة احترافية',
      button: 'تواصل'
    },
    faq: {
      title: 'الأسئلة الشائعة (FAQ)',
      rechargeQuestion: 'كيف أقوم بشحن رصيدي؟',
      rechargeAnswer: 'يمكنك شحن رصيدك من خلال بوابة الدفع الآمنة الخاصة بنا. انتقل إلى حسابي > شحن الرصيد واتبع التعليمات.',
      withdrawQuestion: 'كيف أقوم بسحب الأموال؟',
      withdrawAnswer: 'يمكن السحب من خلال حسابي > سحب. تأكد من توثيق حسابك.',
      minRechargeQuestion: 'ما هو الحد الأدنى لمبلغ الشحن؟',
      minRechargeAnswer: 'الحد الأدنى لمبلغ الشحن هو ${currency}68.',
      withdrawTimeQuestion: 'كم يستغرق السحب من الوقت؟',
      withdrawTimeAnswer: 'تتم معالجة عمليات السحب عادةً في غضون 24 ساعة.',
      securityQuestion: 'هل معلوماتي آمنة؟',
      securityAnswer: 'نعم، نحن نستخدم تقنية التشفير القياسية لحماية معلوماتك الشخصية والمالية.'
    }
  },
  my: {
    inviteCode: 'رمز الدعوة',
    copy: 'نسخ',
    copySuccess: 'تم النسخ بنجاح',
    copyFailed: 'فشل النسخ',
    online: 'متصل',
    accountBalance: 'مبلغ الحساب',
    balance: 'الرصيد',
    accountBalanceTrend: 'اتجاه الرصيد',
    todayCommission: 'عمولة اليوم',
    totalCommission: 'إجمالي العمولة',
    today: 'اليوم',
    total: 'الإجمالي',
    todayOrders: 'طلبات اليوم',
    orderCount: 'عدد الطلبات',
    recharge: 'شحن الرصيد',
    withdraw: 'سحب',
    rechargeRecord: 'سجل الشحن',
    withdrawRecord: 'سجل السحب',
    accountDetails: 'تفاصيل الحساب',
    receivingAccount: 'حساب الاستلام',
    bankAccount: 'حساب بنكي',
    bankAccountDesc: 'حساب بنكي',
    usdt: 'USDT',
    usdtDesc: 'عنوان USDT',
    connect: 'ربط',
    teamManagement: 'إدارة الفريق',
    viewTeam: 'عرض الفريق',
    changePassword: 'تغيير كلمة المرور',
    changeWithdrawPassword: 'تغيير كلمة مرور السحب',
    passwordSettings: 'إعدادات كلمة المرور',
    logout: 'تسجيل الخروج',
    signOut: 'خروج',
    version: 'الإصدار'
  },
  changePasswordPage: {
    currentPassword: 'كلمة مرور الدخول الحالية',
    currentPasswordPlaceholder: 'أدخل كلمة المرور الحالية',
    newPassword: 'كلمة مرور الدخول الجديدة',
    newPasswordPlaceholder: 'أدخل كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    confirmPasswordPlaceholder: 'تأكيد كلمة المرور الجديدة',
    notice: 'تُستخدم كلمة مرور الدخول للوصول إلى الحساب. يجب أن تتكون كلمة المرور من 6 أحرف على الأقل، وأن تحتوي على أحرف وأرقام لضمان الأمان.',
    updateButton: 'تحديث كلمة المرور',
    errorOldPassword: 'الرجاء إدخال كلمة المرور الحالية',
    errorNewPassword: 'الرجاء إدخال كلمة المرور الجديدة',
    errorConfirmPassword: 'الرجاء تأكيد كلمة المرور الجديدة',
    errorPasswordMismatch: 'كلمات المرور غير متطابقة',
    errorPasswordLength: 'يجب أن تتكون كلمة المرور من 6 أحرف على الأقل',
    errorPasswordFormat: 'يجب أن تحتوي كلمة المرور على أحرف وأرقام'
  },
  changeWithdrawPasswordPage: {
    currentPassword: 'كلمة مرور السحب الحالية',
    currentPasswordPlaceholder: 'أدخل كلمة مرور السحب الحالية',
    newPassword: 'كلمة مرور السحب الجديدة',
    newPasswordPlaceholder: 'أدخل كلمة مرور السحب الجديدة',
    confirmPassword: 'تأكيد كلمة مرور السحب',
    confirmPasswordPlaceholder: 'تأكيد كلمة مرور السحب الجديدة',
    notice: 'تُستخدم كلمة مرور السحب لعمليات سحب الأموال. يجب أن تتكون كلمة المرور من 6 أحرف على الأقل، وأن تحتوي على أحرف وأرقام لضمان الأمان.',
    updateButton: 'تحديث كلمة مرور السحب',
    errorOldPassword: 'الرجاء إدخال كلمة مرور السحب الحالية',
    errorNewPassword: 'الرجاء إدخال كلمة مرور السحب الجديدة',
    errorConfirmPassword: 'الرجاء تأكيد كلمة مرور السحب',
    errorPasswordMismatch: 'كلمات المرور غير متطابقة',
    errorPasswordLength: 'يجب أن تتكون كلمة المرور من 6 أحرف على الأقل',
    errorPasswordFormat: 'يجب أن تحتوي كلمة المرور على أحرف وأرقام'
  },
  details: {
    loading: 'جارٍ التحميل...',
    noRecords: 'لا توجد سجلات',
    noMore: 'لا يوجد المزيد',
    time: 'الوقت',
    type: 'النوع',
    amount: 'المبلغ',
    balance: 'الرصيد',
    remark: 'ملاحظة',
    type0: 'أخرى',
    type1: 'شحن الرصيد',
    type2: 'سحب',
    type3: 'معاملة',
    type4: 'عمولة الطلب',
    type5: 'عمولة الإحالة',
    type8: 'رفض السحب'
  },
  rechargeRecord: {
    offline: 'شحن دون اتصال',
    online: 'شحن عبر الإنترنت',
    loading: 'جارٍ التحميل...',
    noRecords: 'لا توجد سجلات',
    orderNo: 'رقم الطلب',
    rechargeAmount: 'مبلغ الشحن',
    rechargeTime: 'وقت الشحن',
    payMethod: 'طريقة الدفع',
    rechargeStatus: 'حالة الشحن',
    noMore: 'لا يوجد المزيد',
    statusPending: 'قيد المراجعة',
    statusApproved: 'تمت الموافقة',
    statusFailed: 'فشل التوثيق',
    statusEmpty: ''
  },
  withdrawRecord: {
    loading: 'جارٍ التحميل...',
    noRecords: 'لا توجد سجلات',
    orderNo: 'رقم الطلب',
    withdrawAmount: 'مبلغ السحب',
    withdrawTime: 'وقت السحب',
    withdrawAddress: 'عنوان السحب',
    withdrawStatus: 'حالة السحب',
    noMore: 'لا يوجد المزيد',
    statusPending: 'قيد المعالجة',
    statusApproved: 'تم السحب بنجاح',
    statusFailed: 'فشل السحب',
    statusEmpty: ''
  },
  withdraw: {
    title: 'سحب',
    method: 'طريقة السحب',
    methodSubtitle: 'الرجاء اختيار طريقة السحب الخاصة بك',
    bankInfo: 'معلومات الحساب البنكي',
    bankName: 'اسم البنك',
    accountHolder: 'اسم صاحب الحساب',
    bankCard: 'البطاقة البنكية',
    amount: 'مبلغ السحب',
    balance: 'الرصيد',
    withdrawAll: 'سحب الكل',
    paymentPassword: 'كلمة مرور الدفع',
    passwordPlaceholder: 'الرجاء إدخال كلمة مرور الأموال',
    principal: 'المبلغ الأساسي',
    serviceFee: 'رسوم الخدمة',
    netAmount: 'المبلغ الصافي',
    notice: '*الرجاء التحقق من معلومات المستلم بعناية',
    withdrawButton: 'سحب',
    walletAddress: 'عنوان المحفظة',
    walletAddressSubtitle: 'الرجاء إدخال عنوان المحفظة'
  },
  recharge: {
    title: 'شحن الرصيد',
    amount: 'مبلغ الشحن',
    amountSubtitle: 'الرجاء إدخال المبلغ الذي ترغب في شحنه',
    quickSelect: 'اختيار سريع',
    rechargeNow: 'شحن الآن',
    selectPayment: 'اختر طريقة الدفع',
    selectPaymentSubtitle: 'الرجاء اختيار طريقة الدفع المفضلة لديك',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    crypto: 'عملات رقمية',
    bank: 'تحويل بنكي',
    paymentRange: 'الحد الأدنى: {symbol}{minAmount} - الحد الأقصى: {symbol}{maxAmount}',
    rechargeFailed: 'فشل الشحن',
    paymentInfo: 'معلومات الدفع',
    usercode: 'عنوان USDT',
    uploadScreenshot: 'الرجاء إرفاق لقطة شاشة لعملية الدفع',
    clickToUpload: 'انقر لرفع لقطة الشاشة',
    copySuccess: 'تم النسخ بنجاح',
    copyFailed: 'فشل النسخ',
    uploadScreenshotRequired: 'الرجاء رفع لقطة شاشة للدفع',
    submit: 'تقديم',
    submitting: 'جارٍ التقديم...',
    submitSuccess: 'تم التقديم بنجاح',
    submitFailed: 'فشل التقديم'
  },
  bindUsdt: {
    title: 'ربط USDT',
    cardTitle: 'عنوان USDT',
    cardSubtitle: 'أدخل عنوان محفظة USDT الخاصة بك',
    walletAddress: 'عنوان المحفظة',
    walletAddressPlaceholder: 'الرجاء إدخال عنوان محفظة USDT',
    networkType: 'نوع الشبكة',
    networkTypePlaceholder: 'الرجاء اختيار نوع الشبكة',
    withdrawPassword: 'كلمة مرور السحب',
    withdrawPasswordPlaceholder: 'الرجاء إدخال كلمة مرور السحب',
    trc20: 'TRC20',
    trc20Network: 'شبكة TRC20',
    erc20: 'ERC20',
    erc20Network: 'شبكة ERC20',
    securityNotice: 'تنبيه أمني',
    securityText1: '• عنوان USDT الخاص بك مشفر ومحفوظ بأمان',
    securityText2: '• أنت فقط من يمكنك عرض وتعديل هذه المعلومات',
    securityText3: '• يرجى التأكد من أن جميع المعلومات دقيقة',
    buttonText: 'حفظ المعلومات',
    buttonSubtitle: 'ربط عنوان USDT',
    errorWalletAddress: 'الرجاء إدخال عنوان المحفظة',
    errorNetworkType: 'الرجاء اختيار نوع الشبكة',
    errorWithdrawPassword: 'الرجاء إدخال كلمة مرور السحب'
  },
  team: {
    title: 'إدارة الفريق',
    level1: 'فريق المستوى 1',
    level2: 'فريق المستوى 2',
    level3: 'فريق المستوى 3',
    level1Members: 'أعضاء المستوى 1',
    level2Members: 'أعضاء المستوى 2',
    level3Members: 'أعضاء المستوى 3',
    totalMembers: 'إجمالي الأعضاء',
    totalCommission: 'إجمالي العمولة',
    members: 'عضو',
    orders: 'الطلبات',
    commission: 'العمولة',
    noMembers: 'لا يوجد أعضاء حالياً',
    loading: 'جارٍ التحميل...',
    noMore: 'لا يوجد المزيد'
  },
  bindBank: {
    title: 'ربط بطاقة بنكية',
    cardTitle: 'المعلومات البنكية',
    cardSubtitle: 'اختر البنك وأدخل تفاصيل الحساب',
    bankName: 'اسم البنك',
    bankNamePlaceholder: 'الرجاء إدخال اسم البنك',
    cardNumber: 'رقم البطاقة',
    cardNumberPlaceholder: 'الرجاء إدخال رقم البطاقة البنكية',
    realName: 'الاسم الحقيقي',
    realNamePlaceholder: 'الرجاء إدخال الاسم الحقيقي',
    withdrawPassword: 'كلمة مرور السحب',
    withdrawPasswordPlaceholder: 'الرجاء إدخال كلمة مرور السحب',
    securityNotice: 'تنبيه أمني',
    securityText1: '• معلوماتك البنكية مشفرة ومحفوظة بأمان',
    securityText2: '• أنت فقط من يمكنك عرض وتعديل هذه المعلومات',
    securityText3: '• يرجى التأكد من دقة جميع المعلومات',
    buttonText: 'حفظ المعلومات',
    buttonSubtitle: 'ربط حساب بنكي',
    errorBankName: 'الرجاء إدخال اسم البنك',
    errorCardNumber: 'الرجاء إدخال رقم البطاقة',
    errorRealName: 'الرجاء إدخال الاسم الحقيقي',
    errorWithdrawPassword: 'الرجاء إدخال كلمة مرور السحب'
  }
}